(function () {
  if (window.__blusafeCompatibilityCheckerLoaded) return;
  window.__blusafeCompatibilityCheckerLoaded = true;

  var rulesCache = {};

  function fetchJson(url) {
    if (!url) return Promise.resolve(null);
    if (!rulesCache[url]) {
      rulesCache[url] = fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Could not load compatibility rules');
        return response.json();
      });
    }
    return rulesCache[url];
  }

  function readJson(root, selector, fallback) {
    var node = root.querySelector(selector);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || 'null') || fallback;
    } catch (error) {
      return fallback;
    }
  }

  function clear(node) {
    while (node && node.firstChild) node.removeChild(node.firstChild);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function track(eventName, payload) {
    var detail = payload || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, detail));

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish(eventName, detail);
      } catch (error) {
        // Shopify analytics is optional in the theme editor and some storefront contexts.
      }
    }
  }

  function statusCopy(status) {
    if (status === 'compatible') return 'Good news - this should fit your door.';
    if (status === 'probably_compatible') return 'This looks like a fit, but one detail needs checking.';
    if (status === 'not_compatible') return 'This product is not right for your door.';
    return 'Not sure? Send us photos and we will check for you.';
  }

  function statusLabel(status) {
    if (status === 'compatible') return 'Fits your door';
    if (status === 'probably_compatible') return 'Check one detail';
    if (status === 'not_compatible') return 'Try this instead';
    return 'Send photos';
  }

  function productCard(product, root, result, state) {
    var article = el('article', 'blusafe-compatibility__product-card');
    if (product.image) {
      var imageWrap = el('div', 'blusafe-compatibility__product-media');
      var img = document.createElement('img');
      img.src = product.image;
      img.alt = product.title || 'Recommended Blusafe product';
      img.loading = 'lazy';
      imageWrap.appendChild(img);
      article.appendChild(imageWrap);
    }

    var body = el('div', 'blusafe-compatibility__product-body');
    body.appendChild(el('p', 'blusafe-compatibility__eyebrow', 'Recommended product'));
    body.appendChild(el('h3', 'blusafe-compatibility__product-title', product.title || 'Blusafe product'));

    if (product.price) body.appendChild(el('p', 'blusafe-compatibility__price', product.price));
    if (product.available === false) body.appendChild(el('p', 'blusafe-compatibility__warning', 'Currently unavailable to buy online.'));

    var actions = el('div', 'blusafe-compatibility__actions');
    if (product.url) {
      var link = el('a', 'bs-btn bs-btn--secondary bs-btn--md', 'View product');
      link.href = product.url;
      link.addEventListener('click', function () {
        track('product_clicked', {
          checker_type: 'main',
          market: 'uk',
          source_page: window.location.pathname,
          product_handle: product.handle || null,
          result_status: result.status,
          recommended_product_families: [product.family]
        });
      });
      actions.appendChild(link);
    }

    if (product.variantId && product.available !== false) {
      var button = el('button', 'bs-btn bs-btn--primary bs-btn--md', 'Add to cart');
      button.type = 'button';
      button.addEventListener('click', function () {
        button.disabled = true;
        button.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: product.variantId, quantity: 1 })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            button.textContent = 'Added';
            track('add_to_cart_after_checker', {
              checker_type: 'main',
              market: 'uk',
              source_page: window.location.pathname,
              product_handle: product.handle || null,
              lock_type: state.answers.lockType || null,
              result_status: result.status,
              recommended_product_families: [product.family],
              missing_measurements: result.missingChecks || [],
              confidence_score: result.status === 'compatible' ? 100 : 70
            });
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          })
          .catch(function () {
            button.disabled = false;
            button.textContent = 'Try again';
          });
      });
      actions.appendChild(button);
    }

    body.appendChild(actions);
    article.appendChild(body);
    return article;
  }

  function renderPhotoBlock(root, compact) {
    var contactUrl = root.getAttribute('data-contact-url') || '/pages/contact';
    var block = el('aside', compact ? 'blusafe-compatibility__photo blusafe-compatibility__photo--compact' : 'blusafe-compatibility__photo');
    block.appendChild(el('h3', '', 'Send photos for review'));
    block.appendChild(el('p', '', 'Send us clear photos and we will confirm the best Blusafe option.'));
    var list = el('ol', '');
    ['Front of the lock or handle', 'Inside of the lock or handle', 'Door edge with the door open', 'Close-up of the latch, deadbolt or multipoint strip', 'Optional tape-measure photo'].forEach(function (item) {
      list.appendChild(el('li', '', item));
    });
    block.appendChild(list);
    var link = el('a', 'bs-btn bs-btn--primary bs-btn--md', 'Send photos instead');
    link.href = contactUrl;
    link.addEventListener('click', function () {
      track('photo_upload_started', {
        checker_type: compact ? 'mini' : 'main',
        market: 'uk',
        source_page: window.location.pathname
      });
    });
    block.appendChild(link);
    return block;
  }

  function initChecker(root) {
    var body = root.querySelector('[data-compatibility-body]');
    var progress = root.querySelector('[data-compatibility-progress]');
    var startButtons = Array.prototype.slice.call(root.querySelectorAll('[data-compatibility-start]'));
    var photoButtons = Array.prototype.slice.call(root.querySelectorAll('[data-compatibility-photo-start]'));
    var products = readJson(root, '[data-compatibility-products]', []);
    var contactUrl = root.getAttribute('data-contact-url') || '/pages/contact';
    var rulesUrl = root.getAttribute('data-rules-url');
    var state = {
      answers: {},
      family: '',
      questionIndex: 0,
      history: [],
      started: false
    };

    function save() {
      try {
        window.sessionStorage.setItem('blusafeCompatibilityMain', JSON.stringify(state.answers));
      } catch (error) {
        // Session storage is optional.
      }
    }

    function setProgress(text) {
      if (progress) progress.textContent = text || '';
    }

    function renderActions(canGoBack) {
      var actions = el('div', 'blusafe-compatibility__nav');
      if (canGoBack) {
        var back = el('button', 'bs-btn bs-btn--secondary bs-btn--sm', 'Back');
        back.type = 'button';
        back.addEventListener('click', function () {
          var snapshot = state.history.pop();
          if (snapshot) {
            state.answers = snapshot.answers;
            state.family = snapshot.family;
            state.questionIndex = snapshot.questionIndex;
            snapshot.render();
          }
        });
        actions.appendChild(back);
      }
      var restart = el('button', 'bs-btn bs-btn--tertiary bs-btn--sm', 'Start over');
      restart.type = 'button';
      restart.addEventListener('click', renderLockTypes);
      actions.appendChild(restart);

      var photo = el('a', 'bs-btn bs-btn--tertiary bs-btn--sm', 'Send photos instead');
      photo.href = contactUrl;
      photo.addEventListener('click', function () {
        track('photo_upload_started', {
          checker_type: 'main',
          market: 'uk',
          source_page: window.location.pathname,
          lock_type: state.answers.lockType || null
        });
      });
      actions.appendChild(photo);
      return actions;
    }

    function evaluateAndRender(rules) {
      var result = window.BlusafeCompatibility.evaluate({
        mode: 'main',
        productHandle: null,
        answers: state.answers,
        products: products
      });
      renderResult(result);
      track('result_seen', {
        checker_type: 'main',
        market: 'uk',
        source_page: window.location.pathname,
        product_handle: null,
        lock_type: state.answers.lockType || null,
        result_status: result.status,
        recommended_product_families: result.recommendedProducts.map(function (product) { return product.family; }),
        missing_measurements: result.missingChecks,
        confidence_score: result.status === 'compatible' ? 100 : result.status === 'probably_compatible' ? 70 : 30
      });
      return rules;
    }

    function applyOption(question, option, renderCurrent) {
      state.history.push({
        answers: Object.assign({}, state.answers),
        family: state.family,
        questionIndex: state.questionIndex,
        render: renderCurrent
      });
      state.answers[question.id] = option.value;
      if (option.sets) {
        Object.keys(option.sets).forEach(function (key) {
          state.answers[key] = option.sets[key];
        });
      }
      save();

      track('measurement_answered', {
        checker_type: 'main',
        market: 'uk',
        source_page: window.location.pathname,
        lock_type: state.answers.lockType || null,
        question_id: question.id,
        answer: option.value
      });

      fetchJson(rulesUrl).then(function (rules) {
        var nextFamily = window.BlusafeCompatibility.familyForLockType(state.answers.lockType);
        if (nextFamily && nextFamily !== state.family) {
          state.family = nextFamily;
          state.questionIndex = 0;
          renderQuestion(rules);
          return;
        }

        var questions = (rules.mainQuestions || {})[state.family] || [];
        if (state.questionIndex >= questions.length - 1 || option.value === 'not_sure') {
          evaluateAndRender(rules);
          return;
        }

        state.questionIndex += 1;
        renderQuestion(rules);
      });
    }

    function renderQuestion(rules) {
      clear(body);
      var questions = (rules.mainQuestions || {})[state.family] || [];
      var question = questions[state.questionIndex];
      if (!question) {
        evaluateAndRender(rules);
        return;
      }

      setProgress('Step ' + (state.questionIndex + 2) + ' of ' + (questions.length + 1));
      var shell = el('div', 'blusafe-compatibility__question');
      shell.appendChild(el('p', 'blusafe-compatibility__eyebrow', 'A few checks'));
      shell.appendChild(el('h2', 'blusafe-compatibility__question-title', question.text));
      if (question.help) shell.appendChild(el('p', 'blusafe-compatibility__help-text', question.help));

      var options = el('div', 'blusafe-compatibility__options');
      (question.options || []).forEach(function (option) {
        var button = el('button', 'blusafe-compatibility__option', '');
        button.type = 'button';
        button.appendChild(el('span', 'blusafe-compatibility__option-mark', ''));
        button.appendChild(el('span', '', option.label));
        button.addEventListener('click', function () {
          applyOption(question, option, function () { renderQuestion(rules); });
        });
        options.appendChild(button);
      });

      shell.appendChild(options);
      shell.appendChild(renderActions(true));
      body.appendChild(shell);
      var firstButton = body.querySelector('button');
      if (firstButton) firstButton.focus({ preventScroll: true });
    }

    function chooseLockType(lockType, rules) {
      if (!state.started) {
        state.started = true;
        track('checker_start', {
          checker_type: 'main',
          market: 'uk',
          source_page: window.location.pathname
        });
      }

      state.history.push({
        answers: Object.assign({}, state.answers),
        family: state.family,
        questionIndex: state.questionIndex,
        render: renderLockTypes
      });
      state.answers = { lockType: lockType.id };
      state.family = window.BlusafeCompatibility.familyForLockType(lockType.id);
      state.questionIndex = 0;
      save();

      track('lock_type_selected', {
        checker_type: 'main',
        market: 'uk',
        source_page: window.location.pathname,
        lock_type: lockType.id
      });

      if (lockType.id === 'unknown') {
        evaluateAndRender(rules);
        return;
      }
      renderQuestion(rules);
    }

    function renderLockTypes() {
      fetchJson(rulesUrl).then(function (rules) {
        window.BlusafeCompatibility.setRules(rules);
        state.answers = {};
        state.family = '';
        state.questionIndex = 0;
        state.history = [];
        save();
        clear(body);
        setProgress('Step 1 of 4');

        var shell = el('div', 'blusafe-compatibility__question');
        shell.appendChild(el('p', 'blusafe-compatibility__eyebrow', 'Find your setup'));
        shell.appendChild(el('h2', 'blusafe-compatibility__question-title', 'What does your current lock look like?'));
        shell.appendChild(el('p', 'blusafe-compatibility__help-text', 'Choose the option that looks closest. You can send photos at any point.'));

        var grid = el('div', 'blusafe-compatibility__lock-grid');
        (rules.lockTypes || []).forEach(function (lockType) {
          var button = el('button', 'blusafe-compatibility__lock-card', '');
          button.type = 'button';
          button.setAttribute('data-lock-type', lockType.id);
          button.appendChild(el('span', 'blusafe-compatibility__lock-visual blusafe-compatibility__lock-visual--' + lockType.imageKey, ''));
          button.appendChild(el('strong', '', lockType.title));
          button.appendChild(el('span', '', lockType.subtitle));
          button.addEventListener('click', function () {
            chooseLockType(lockType, rules);
          });
          grid.appendChild(button);
        });

        shell.appendChild(grid);
        shell.appendChild(renderActions(false));
        body.appendChild(shell);
      });
    }

    function renderResult(result) {
      clear(body);
      setProgress('Result');
      var shell = el('div', 'blusafe-compatibility__result-card blusafe-compatibility__result-card--' + result.status);
      shell.appendChild(el('p', 'blusafe-compatibility__eyebrow', statusLabel(result.status)));
      shell.appendChild(el('h2', 'blusafe-compatibility__result-title', statusCopy(result.status)));

      var reasons = (result.reasons || []).concat(result.missingChecks || [], result.warnings || []);
      if (reasons.length) {
        var list = el('ul', 'blusafe-compatibility__reason-list');
        reasons.forEach(function (reason) {
          list.appendChild(el('li', '', reason));
        });
        shell.appendChild(list);
      }

      if (result.accessoryRecommendations && result.accessoryRecommendations.length) {
        var accessory = el('div', 'blusafe-compatibility__callout');
        accessory.appendChild(el('strong', '', 'Accessory recommendation'));
        result.accessoryRecommendations.forEach(function (item) {
          accessory.appendChild(el('p', '', item.title + ': ' + item.reason));
        });
        shell.appendChild(accessory);
      }

      if (result.recommendedProducts && result.recommendedProducts.length) {
        var productGrid = el('div', 'blusafe-compatibility__product-grid');
        result.recommendedProducts.forEach(function (product) {
          productGrid.appendChild(productCard(product, root, result, state));
        });
        shell.appendChild(productGrid);
      }

      shell.appendChild(renderPhotoBlock(root, false));
      shell.appendChild(renderActions(true));
      body.appendChild(shell);
    }

    startButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!state.started) {
          state.started = true;
          track('checker_start', {
            checker_type: 'main',
            market: 'uk',
            source_page: window.location.pathname
          });
        }
        renderLockTypes();
      });
    });

    photoButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        track('photo_upload_started', {
          checker_type: 'main',
          market: 'uk',
          source_page: window.location.pathname
        });
      });
    });

    if (body && !body.children.length) {
      renderLockTypes();
    }
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-compatibility-checker]')).forEach(initChecker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
